import React, { Fragment } from 'react';
import {
    List,
    Datagrid,
    TextField,
    SelectField,
    CardActions
} from 'react-admin';
import DownloadButton from './DownloadButton';
import ReportCreateButton from './ReportCreateButton';
import ReportDeleteButton from './ReportDeleteButton';
import { Pagination } from 'react-admin';
import DateField from '../common/DateField';

const ReportsActions = props => (
    <CardActions>
        <ReportCreateButton {...props} />
    </CardActions>
);

const ReportList = props => (
    <List {...props} actions={<ReportsActions />} sort={{ field: 'requestDateTime', order: 'DESC' }} bulkActionButtons={false} >
        <Datagrid>
            <DateField source="startDate" sortable={false} />
            <DateField source="endDate" sortable={false} />
            <DateField source="requestDateTime" showTime={true} sortable={false} />
            <SelectField
                source="status"
                choices={[
                    { id: 0, name: 'resources.reports.enums.status.processing' },
                    { id: 1, name: 'resources.reports.enums.status.processing' },
                    { id: 2, name: 'resources.reports.enums.status.failed' },
                    { id: 3, name: 'resources.reports.enums.status.completed' }
                ]}
                sortable={false} />
            <DownloadButton {...props} />
            <ReportDeleteButton  {...props} />
        </Datagrid>
    </List>
);

export default ReportList;
